import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { ActionButton, UserAvatar, colors } from "@zfp-akademie-a-s/zfp-design";
import { EditIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import type { AnalysisClientItemRelationType } from "Infrastructure/ApiZfp/Schema";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { format } from "date-fns";

const StyledWrapper = styled(Box)`
  ${({ theme }) => `
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: ${theme.spacing(16)};
    width: 100%;
    border: 1px solid ${colors.borderLight};
    border-radius: ${theme.spacing(Radius.L)};
    padding: ${theme.spacing(Spacing.XL)};
  `}
`;

type Props = {
  readonly clientId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly birthDate: string;
  readonly clientRelationType: AnalysisClientItemRelationType;
  readonly onEdit?: (clientId: string, clientRelationType: AnalysisClientItemRelationType) => void;
};

export const FamilyMember: React.FC<Props> = ({ clientId, firstName, lastName, birthDate, clientRelationType, onEdit }) => {
  const { t } = useResource();
  const fullName = `${firstName} ${lastName}`;

  return (
    <StyledWrapper
      boxShadow={1}
      onClick={() => {
        onEdit?.(clientId, clientRelationType);
      }}
    >
      <Box display="flex" alignItems="center">
        <UserAvatar size="small" firstName={firstName} lastName={lastName} />
        <Box display="flex" flexDirection="column" ml={Spacing.L}>
          <Typography variant="caption" fontWeight={600}>
            {fullName}
          </Typography>
          <Typography variant="caption" color="secondary">
            {birthDate ? format(new Date(birthDate), "d. M. yyyy") : "-"}
          </Typography>
        </Box>
      </Box>
      {onEdit && <ActionButton label={t(Resources.Common.Edit)} icon={<EditIcon />} />}
    </StyledWrapper>
  );
};
